var exports = {
  "DataMarquee": "DataMarquee__z4aEos",
  "DataMarquee--dark": "DataMarquee--dark__7jqUnS",
  "DataMarquee--scrolled": "DataMarquee--scrolled__CvnYwI",
  "DataMarquee__viewport": "DataMarquee__viewport__YNeuHH",
  "DataMarquee__track": "DataMarquee__track__zxp-zo",
  "DataMarquee__block": "DataMarquee__block__3A2TYk",
  "DataMarquee__event": "DataMarquee__event__kLHQ9M",
  "DataMarquee__stat": "DataMarquee__stat__mUqdMq",
  "DataMarquee__event_label": "DataMarquee__event_label__JeRfgb",
  "DataMarquee__event_label_text": "DataMarquee__event_label_text__L1KhJp",
  "DataMarquee__event_icon": "DataMarquee__event_icon__GVbthv",
  "DataMarquee__event_details": "DataMarquee__event_details__EszPbX",
  "DataMarquee__event_separator": "DataMarquee__event_separator__Y7uHX7",
  "DataMarquee__stat_value": "DataMarquee__stat_value__UlEd0y",
  "DataMarquee__control": "DataMarquee__control__gdvhuc",
};

__webpack_require__.r(module.exports = exports);
